export default __webpack_public_path__ + "static/media/facility_03_5.25daac04.png";